import * as React from 'react';
import {
  PaginatorAndListSettings,
  Search,
  Section,
  useCacheQuery,
  useQueryOptionsFromSearchParams,
} from 'gossamer-front-end';
import { Event } from 'cb-model';
import { getFilter, QueryOptions } from 'gossamer-unified';
import { useInstitutionFilter } from '../institution/useInstitutionFilter';

export const EventFutureSearch = (): React.JSX.Element => {
  // prevent infinite re-render
  const now = React.useRef(new Date().toISOString());
  const initialQueryOptions = useInstitutionFilter({
    where: {
      and: [
        getFilter('institution_id', 'eq', '', 'hidden'),
        getFilter('title', 'sw', ''),
        getFilter('start_at', 'gt', now.current, 'hidden'),
        getFilter('visibility_limit', 'ne', 'cancelled', 'hidden'),
      ],
    },
    order: [['start_at', 'ASC']],
  } as QueryOptions);
  const [queryOptions, setQueryOptions] = useQueryOptionsFromSearchParams(Event, initialQueryOptions);
  const gCacheQueryItem = useCacheQuery(Event, queryOptions);
  return (
    <Section>
      <PaginatorAndListSettings
        entity={Event}
        gCacheQuery={gCacheQueryItem}
        queryOptions={queryOptions}
        render={Search}
        setQueryOptions={setQueryOptions}
      />
    </Section>
  );
};
